import React from "react";

const XIcon52pxSvg = (props) => {
  return (
    <svg
      {...props}
      width="48"
      height="53"
      viewBox="0 0 48 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.84399"
        y="2.93042"
        width="51.9938"
        height="12.0008"
        rx="6.00038"
        transform="rotate(40.8151 7.84399 2.93042)"
        fill="#006EFF"
      />
      <rect
        x="41.2483"
        y="6.03149"
        width="54.2049"
        height="12"
        rx="6"
        transform="rotate(120.174 41.2483 6.03149)"
        fill="#006EFF"
      />
    </svg>
  );
};

export default XIcon52pxSvg;
